import { lazy } from 'react';

//import Home from '../pages/Home'

//import Games from '../pages/Games/Games'
//import Scratch from '../pages/Games/Scratch'
//import Chat from '../pages/Games/Chat'

//import Profile from '../pages/Profile/Profile'

//import Blog from '../pages/Blog/Blog'

//import App from '../pages/Apps/App'
//import RecoveryVault from '../pages/Apps/RecoveryVault'
//import SortAlgorithms from '../pages/Apps/SortAlgorithms'
//import PathfindingAlgorithms from '../pages/Apps/PathfindingAlgorithms'
//import Password from '../pages/Apps/Password'

//import Login from '../pages/other/Login'

const Home = lazy(() => import('../pages/Home'));

const Games = lazy(() => import('../pages/Games/Games'));
const Scratch = lazy(() => import('../pages/Games/Scratch'));
const Chat = lazy(() => import('../pages/Games/Chat'));

const Profile = lazy(() => import('../pages/Profile/Profile'));

const Blog = lazy(() => import('../pages/Blog/Blog'));

const App = lazy(() => import('../pages/Apps/App'));
const RecoveryVault = lazy(() => import('../pages/Apps/RecoveryVault'));
const SortAlgorithms = lazy(() => import('../pages/Apps/SortAlgorithms'));
const PathfindingAlgorithms = lazy(() => import('../pages/Apps/PathfindingAlgorithms'));
const Password = lazy(() => import('../pages/Apps/Password'));
const Special = lazy(() => import('../pages/Apps/Special'));
const ExperimentalActivityData = lazy(() => import('../pages/Apps/ExperimentalActivityData'));
const ExperimentalMySQL = lazy(() => import('../pages/Apps/ExperimentalMySQL'));
const AdminUserManager = lazy(() => import('../pages/Apps/AdminUserManager'));
const CustomEncrypt = lazy(() => import('../pages/Apps/CustomEncrypt'));
const DiveDeep = lazy(() => import('../pages/Apps/DiveDeep'));

const Login = lazy(() => import('../pages/other/Login'));

export const HOME = {
    label: "Home",
    path: "/",
    component: Home,
}

export const GAMES = {
    label: "Games Moved",
    path: "https://joshia-t.vercel.app/games",
    component: Games,
}

export const GAMES_SCRATCH = {
    label: "Scratch",
    path: "/games/scratch/:id",
    component: Scratch,
}

export const PROFILE = {
    label: "Profile Moved",
    path: "https://joshia-t.vercel.app/profile",
    component: Profile,
}

export const LOG_IN = {
    label: "Log In",
    path: "/login",
    component: Login,
}

export const CHAT = {
    label: "Chat",
    path: "/chat",
    component: Chat,
}

export const BLOG = {
    label: "Blog Moved",
    path: "https://joshia-t.vercel.app/blog",
    component: Blog,
}

export const APP = {
    label: "Apps",
    path: "/apps",
    component: App,
}

export const APP_RECOVERYVAULT = {
    label: "Recovery Vault",
    path: "/apps/recovery-vault",
    component: RecoveryVault,
}

export const APP_SORTALGORITHMS = {
    label: "Sorting Algorithms",
    path: "/apps/sort-algorithms",
    component: SortAlgorithms,
}

export const APP_PATHFINDINGALGORITHMS = {
    label: "Pathfinding Algorithms",
    path: "/apps/pathfinding-algorithms",
    component: PathfindingAlgorithms,
}

export const APP_PASSWORD = {
    label: "Password",
    path: "/apps/password",
    component: Password,
}

export const APP_SPECIAL = {
    label: "Special",
    path: "/apps/special",
    component: Special,
}

export const APP_EXPERIMENTAL_ACTIVITYDATA = {
    label: "ExperimentalActivityData",
    path: "/apps/experimental-activity-data",
    component: ExperimentalActivityData,
}

export const APP_EXPERIMENTAL_MYSQL = {
    label: "ExperimentalMySQL",
    path: "/apps/experimental-mysql",
    component: ExperimentalMySQL,
}

export const APP_ADMIN_USERMANAGER = {
    label: "User Manager",
    path: "/apps/admin-user-manager",
    component: AdminUserManager,
}

export const APP_CUSTOMENCRYPT = {
    label: "Custom Encrypt",
    path: "/apps/custom-encrypt",
    component: CustomEncrypt,
}

export const APP_DIVE_DEEP = {
    label: "Dive Deep",
    path: "/apps/dive-deep",
    component: DiveDeep,
}

export const APP_DIVE_DEEPER = {
    label: "Dive Even Deepr",
    path: "/apps/dive-deep/tag/:tag",
    component: DiveDeep,
}

export const BACKEND_API = "https://joshia-t.herokuapp.com";
export const REROUTE_API = "https://joshia-t-reroute.herokuapp.com";

export const AllRoutes = [HOME, GAMES, GAMES_SCRATCH, PROFILE, LOG_IN, CHAT, BLOG, APP, APP_RECOVERYVAULT, APP_SORTALGORITHMS, APP_PATHFINDINGALGORITHMS, APP_PASSWORD, APP_SPECIAL, APP_EXPERIMENTAL_ACTIVITYDATA, APP_EXPERIMENTAL_MYSQL, APP_ADMIN_USERMANAGER, APP_CUSTOMENCRYPT, APP_DIVE_DEEP, APP_DIVE_DEEPER];
export const NavRoutes = [GAMES, PROFILE, BLOG, APP];